import { IntegrationVersion } from 'api/usePublisherIntegrationTest';

export const selectStylesConfig = {
  base: {
    minWidth: 80,
    height: 40,
    '& .MuiSelect-select': {
      padding: '8px 12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e5e7eb'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d1d5db'
    }
  },
  enabled: {
    backgroundColor: '#fff'
  },
  disabled: {
    backgroundColor: '#f9fafb'
  }
};

export const docsUrls = {
  authenticatePlayer: 'https://docs.appcharge.com/api-reference/webstore/player-authentication/authenticate-player-callback',
  initiateGameAuth: 'https://docs.appcharge.com/api-reference/webstore/player-authentication/initiate-game-auth-callback',
  personalizeWebstore: 'https://docs.appcharge.com/api-reference/webstore/personalization/personalize-webstore-callback',
  grantAward: 'https://docs.appcharge.com/api-reference/checkout/awards/grant-award-callback',
  eventsCenter: {
    [IntegrationVersion.V1]: 'https://docs.appcharge.com/api-reference/events/v1/introduction',
    [IntegrationVersion.V2]: 'https://docs.appcharge.com/api-reference/events/v2/introduction'
  }
};

export const toastMessages = {
  projectInfoSuccess: 'Project info updated successfully',
  projectInfoError: 'Failed to update project info',
  portalInfoSuccess: 'Portal settings were successfully updated',
  portalInfoError: 'Failed to update portal settings',
  authPlayerSuccess: 'Authenticate Player Callback updated successfully',
  authPlayerError: 'Failed to update callback',
  grantAwardSuccess: 'Grant Award Callback updated successfully',
  grantAwardError: 'Failed to update callback',
  personalizeSuccess: 'Personalize Web Store Callback updated successfully',
  personalizeError: 'Failed to update callback',
  eventsWebhookSuccess: 'Events Webhook updated successfully',
  eventsWebhookError: 'Failed to update webhook',
  otpSuccess: 'Initiate Game Auth Callback updated successfully',
  otpError: 'Failed to update callback',
  jwtEnabled: 'JWT Secret enabled',
  jwtDisabled: 'JWT Secret disabled',
  jwtError: 'Failed to update JWT Secret',
  urlCopied: 'URL copied to clipboard',
  appsFlyerSuccess: 'AppsFlyer settings updated successfully',
  appsFlyerError: 'Failed to update AppsFlyer settings'
};

